import React from 'react';
import './EditableText.scss';

const EditableText = ({ type = 'text', text, isEditing, onChange, highlight = false, ...rest }) => {
  return isEditing ? (
    <input
      className={highlight ? 'editable-highlight' : undefined}
      type={type}
      defaultValue={text}
      onChange={onChange}
      {...rest}
    />
  ) : (
    <div>{text || '-'}</div>
  );
};

export default EditableText;
